import { EventCategoryKeys } from '~/enums/event';

/** 該当するカテゴリーを文字列で返す */
export const formatCategory = (category: string) => {
  switch (category) {
    case EventCategoryKeys.EVENT:
      return 'イベント';
    case EventCategoryKeys.TASTING:
      return 'テイスティング';
    case EventCategoryKeys.DINNER_LUNCH:
      return 'ディナー・ランチ';
    case EventCategoryKeys.SEMINAR:
      return 'セミナー';
    default:
      return 'その他';
  }
};

/** 該当するカテゴリーのキャンセル可能日を返す */
export const getCancellablePeriod = (category: string) => {
  switch (category) {
    case EventCategoryKeys.EVENT:
      return 7;
    case EventCategoryKeys.DINNER_LUNCH:
      return 10;
    default:
      return 2;
  }
};
